import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MultiYearComparisonModule } from '@modeso/aumico-lib-companies-fe';
import { I18NextModule } from 'angular-i18next';
import { AnalyticsCompanyPage } from './analytics-company.page';

@NgModule({
    imports: [CommonModule, I18NextModule, MultiYearComparisonModule],
    declarations: [AnalyticsCompanyPage],
    exports: [AnalyticsCompanyPage],
})
export class AnalyticsCompanyModule {}
